import axios from 'axios';
import { toast } from 'react-toastify';
import { push } from 'connected-react-router';

// URIs
import serverURI from '../../config/URI';
// Helpers
import errorHandler from '../helpers/errorHandler';

export const FINDING_SETTLEMENTS = () => ({ type: 'FINDING_SETTLEMENTS', });
export const FINDING_SETTLEMENTS_SUCCESS = () => ({ type: 'FINDING_SETTLEMENTS_SUCCESS', });
export const FINDING_SETTLEMENTS_ERROR = () => ({ type: 'FINDING_SETTLEMENTS_ERROR', });

export const findSettlement = (find, dispatch) => {
  dispatch({ type: FINDING_SETTLEMENTS });

  axios
    .post(`${serverURI}/api/settlement/advertise/find`, find)
    .then((res) => {
      dispatch({ type: FINDING_SETTLEMENTS_SUCCESS, 
        payload: {
          find_total: res.data.total,
          find_advertises: res.data.advertises, 
        },
      });
    })
    .catch((err) => {
      dispatch({ type: FINDING_SETTLEMENTS_ERROR, payload: err });
      errorHandler(err);
    });
};

export const removeSettlement = (dispatch) => {
  dispatch({ type: FINDING_SETTLEMENTS_SUCCESS, 
    payload: {
      find_total: 0,
      find_advertises: [], 
    },
  });
};